import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../style/DeviceErrorList.css';
import Icon, {CLOSE} from "./Icon";

class DeviceErrorList extends Component {
    render() {
        return (this.props.errors &&
            <div className={'device_error_list-wrapper'}>
                <div className={'device_error_list-list'}>
                    {Object.keys(this.props.errors).map(k => {
                        return (
                            <div key={k}
                                 className={'device_error_list-list-item'}>
                                {this.props.errors[k]}
                            </div>
                        );
                    })}
                </div>
                <div onClick={this.props.clearErrors}
                     className={'device_error_list-clear-button'}>
                    <Icon iconName={CLOSE}/>
                </div>
            </div>
        );
    }
}

DeviceErrorList.propTypes = {
    clearErrors: PropTypes.func,
    errors: PropTypes.object.isRequired

};

export default DeviceErrorList;


// WEBPACK FOOTER //
// ./src/component/DeviceErrorList.jsx